import React, { Fragment } from 'react';
import { Route } from 'react-router';
import ConnectToShopify from '../../../../products/products/Shopify/components/ConnectToShopify';
import ShopifySettingsPage from '../../../../products/products/Shopify/components/ShopifySettingsPage';
import { BRAND_USER_BASE_URL, SHOP_USER_BASE_URL } from '../../../../constants';
import BrandShopifyIntegration from './BrandShopifyIntegrationContainer';
import ShopShopifyIntegration from './ShopShopifyIntegrationContainer';
import { requireConnection, requireSettings } from './routerHooks';
import { CONNECT, INTEGRATIONS_PATH, SETTINGS, SHOPIFY_PATH } from '../constants';
import { requireProductsEcommercePermission } from '../../../../auth/routerHooks';

const ShopifyIntegrationSettingsRoutes = (store, baseUrl) => (
  <Fragment>
    <Route
      path={CONNECT}
      component={ConnectToShopify}
      onEnter={requireSettings(store, `${baseUrl}/${INTEGRATIONS_PATH}${SHOPIFY_PATH}`)}
    />
    <Route
      path={SETTINGS}
      component={ShopifySettingsPage}
      onEnter={requireConnection(store, `${baseUrl}/${INTEGRATIONS_PATH}${SHOPIFY_PATH}`)}
    />
  </Fragment>
);

export const ShopShopifyRoutes = store => (
  <Route
    path="shopify"
    component={ShopShopifyIntegration}
    onEnter={requireProductsEcommercePermission(store)}
  >
    {ShopifyIntegrationSettingsRoutes(store, SHOP_USER_BASE_URL)}
  </Route>
);

export const BrandShopifyRoutes = store => (
  <Route
    path="shopify"
    component={BrandShopifyIntegration}
    onEnter={requireProductsEcommercePermission(store)}
  >
    {ShopifyIntegrationSettingsRoutes(store, BRAND_USER_BASE_URL)}
  </Route>
);
